import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Paper,
  Typography,
  makeStyles,
  Chip,
  Tabs,
  Tab,
  IconButton,
} from "@material-ui/core";
import {  Assignment, InsertChart, Search} from "@material-ui/icons";
import { BarraAvance, TablaV2 } from "components";
import { useEffect, useState } from "react";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import serviciosCatalogo from "utils/serviciosCatalogo";
import NumberFormat from "react-number-format";
import { useForm } from "react-hook-form";
import periodo from "assets/finicio.svg";
import sistema from "assets/sistema.svg";
import InputPeriodo from "./Components/Periodo";
import AutocompleteSistema from "./Components/AutocompleteSistema";
import imgSistema from "assets/sistema_sel.png";
import imghpro from "assets/horas_proy.png";
import Cardazul from "./Components/CardAzul";
import TabPanel from "./Components/TabPanels";
import Detalles from "./Components/Detalle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  containerSistemas: {
    paddingTop: theme.spacing(3),
  },
  input: {
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    borderRadius: 50,
    backgroundColor: theme.palette.input.main,
    height: "3rem",
  },
  buton: {
    borderRadius: "40px",
    backgroundColor: "#00538b",
    color: "#ffffff",
    fontWeight: 800,
  },indicator: {
     color: "#00538b",
  }

}));
const AvanceSolicitud = ({permisos, usuario}) => {
  const classes = useStyles();
  const { getValues, register, errors, control } = useForm();
  const [mensaje, setMensaje] = useState({ open: false });
  const [cargando, setCargando] = useState(false);
  
  const dateNow = new Date();
  const fechafin = `${dateNow.getFullYear()}-12-31`;
  const fechainicio = `${dateNow.getFullYear()}-01-01`;

  const [fechad, setFechad] = useState({
    finicio: fechainicio,
    ffin: fechafin,
  });

  const format = (date) => {
    if(date != null){
      const options = { day:"2-digit", month:"2-digit", year:'numeric' };
      const formattedDate = new Date(date+'T12:00:00').toLocaleDateString("es-MX", options);
      const [d,m,y] = formattedDate.split("/");
      return `${d}-${m}-${y}`;
    } else {
      return 'N/A';
    }
  
  };
  const formatPeriodo = (date) => {
    const options = { day:'numeric', month:'long', year:'numeric' };
    const formattedDate = new Date(date+'T12:00:00').toLocaleDateString("es-MX", options);
    const [day,d1 , month, d2,year] = formattedDate.split(" ");
    return `${day} ${month} ${year}`;
  };

  const [sistemaSeleccionado, setSistemaSeleccionado] = useState({ idproyecto: 0, nproyecto: "TODOS" });
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const [catalogos, setCatalogos] = useState({ sistemas: [] });
  const [masindc, setMasindc] = useState(1);

  const cambioProyectoSeleccionado = (sistema) => {
    if(sistema != null){
      serviciosSolicitudes.getInfoGeneral(
        (data) => {
          setSistemaSeleccionado(data.solicitudes);
          setFechad({ ...getValues("periodo") });
        },
        setCargando,
        { sistema: sistema, ...getValues("periodo"), tabpanel : masindc }
      );
    } 
  };
  const columns = [
    { label: "Título", name: "titulo", filtrar: true, tamano: '15' },
    { label: "Gerencia", name: "ngerencia", filtrar: true, tamano: '15' },
    { label: "Prioridad", name: "nprioridad", filtrar: true , tamano:'7'},
    { label: "Tipo", name: "ntipo_solicitud", filtrar: true, tamano: '5'},
    { label: "Sistema", name: "sistema", filtrar: true },
    { label:"Modulo", name: "nmodulo", filtrar:true},
    { label: "Hrs. Propuestas", name: "horaSol", filtrar: true, tamano:'9',
      type: {
        type: "componente",
        accion: (row) => (
          <Typography align="center" style={{fontSize:12}}>
            <NumberFormat
              value={row["horaSol"]}
              thousandSeparator=","
              decimalScale={0}
              suffix=" hrs"
              displayType="text"
            />
          </Typography>
        ),
    },},
    { label: "# Tareas", name: "nTareas", filtrar: true},
    { label: "% Avance", name: "avance", filtrar: true,
      type: { type: 'componente', accion: row => <BarraAvance avance={row.avance} /> }
   },
    { label: "F. Solicitud", name: "f_solicitud", filtrar: true},
    { label: "F. Inicio", name: "finicio", filtrar: true,
      type: {
        type: "componente",
        accion: row => <Typography style={{fontSize:12}} align="center">{format(row.finicio)}</Typography>
      } },
    { label: "F. Término", name: "ffinal", filtrar: true,
      type:{
        type: 'componente',
        accion: row => <Typography style={{fontSize:12}} align="center">{format(row.ffinal)}</Typography>
      }  },
    { label: "Estatus", name: "nestatus", filtrar: true,
      type: {type: 'componente', accion: row => <Chip style={{backgroundColor:row.stColor}} size="small" label={ <Typography display="inline" variant="caption">{row.nestatus}</Typography>}/>} },
    {
      label: "Cumplimiento Hrs.",
      name: "cumplimientohoras", 
      filtrar: true,
      tamano: '11',
      type: {
        type: "componente",
        accion: (row) => (
          <Typography align="center" style={{fontSize:12}}>
            <NumberFormat
              value={row["cumplimientohoras"]}
              thousandSeparator=","
              decimalScale={0}
              suffix="%"
              displayType="text"
            />
          </Typography>
        ),
      },
    },
    {
      label: "% Eficiencia.",
      name: "eficienciaHoras", 
      filtrar: true,
      tamano: '8',
    },
  ];
  
  const indexSeleccionado = catalogos.sistemas.findIndex(
    (sistema) => sistema.idproyecto == sistemaSeleccionado?.idproyecto
  );
  const handleChange = (e,v) => {
    setMasindc(v);
    console.log(getValues('sisText'));
    serviciosSolicitudes.getInfoGeneral(
      (data) => {
        setSistemaSeleccionado(data.solicitudes);
      },
      setCargando,
      {
        sistema: getValues('sisText'),
        ...getValues('periodo'),
        tabpanel : v
      }
    );
  };
  useEffect(() => {
    setFechad({ finicio: fechainicio, ffin: fechafin });
    serviciosSolicitudes.getInfoGeneral(
      (data) => {
        setSistemaSeleccionado(data.solicitudes);
      },
      setCargando,
      {
        sistema: sistemaSeleccionado,
        finicio: fechad.finicio,
        ffin: fechad.ffin,
        tabpanel : masindc
      }
    );
    serviciosCatalogo.sistemasAll(
      (data) => {
        setCatalogos({ sistemas: [...data.proyectos.filter((p=> [3,9].includes(p.idestatus)))] });
      },
      setCargando,
      {}
    );
  }, []);
  return (
    <>
      <Card>
        <CardContent>
          <Grid container justifyContent="center">
            <Grid item container xs={12} alignItems="center" justifyContent="center">
              <Typography>HOLA, BIENVENIDO&nbsp;{usuario[0].nombre}</Typography>
            </Grid>
            <Grid item container>
              <Grid item container xs={6} justifyContent="center">
                <Grid item container xs={12} justifyContent="center">
                  <img src={periodo} width="10%" />
                </Grid>
                <Grid item xs={12}>
                  <Typography align="center">Periodo</Typography>
                </Grid>
                <Grid item xs={9}>
                  <InputPeriodo control={control} name="periodo" val={fechad} errors={errors}/>
                </Grid>
              </Grid>
              <Grid item container xs={6} alignItems="center" justifyContent="center">
                <Grid item xs={12} container justifyContent="center">
                  <img src={sistema} width="10%" />
                </Grid>
                <Grid item xs={12}>
                  <Typography align="center">Sistema</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Paper className={classes.input}>
                    <AutocompleteSistema
                      control={control}
                      name='sisText'
                      options={catalogos.sistemas}
                      onChange={cambioProyectoSeleccionado}
                      // defaultValue={sistemaSeleccionado}
                      defaultValue={{idproyecto: sistemaSeleccionado.idproyecto, nproyecto: sistemaSeleccionado.nproyecto}}
                      optionSelected={{
                        id: "idproyecto",
                        label: "nproyecto",
                      }}
                    />
                    <IconButton title="Buscar" onClick={() => {
                      if(sistema != null){
                        serviciosSolicitudes.getInfoGeneral(
                        (data) => {
                          setSistemaSeleccionado(data.solicitudes);
                          setFechad({ ...getValues("periodo") });
                        },
                        setCargando,
                        {  sistema: getValues('sisText'), ...getValues('periodo'), tabpanel : masindc }
                      ); } }}>
                      <Search/>
                    </IconButton>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container spacing={4} direction="column" className={classes.containerSistemas}>
        {sistemaSeleccionado ? (
          <Grid key={sistemaSeleccionado.idproyecto} item container>
            <Grid item xs>
              <Card>
                <CardHeader />
                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item container xs={12}>
                      <Cardazul
                        img={imghpro}
                        label="HORAS POR PROYECTO:"
                        value={sistemaSeleccionado?.hrsProyecto}
                        ext=' hrs'
                      />
                      <Cardazul
                        img={imgSistema}
                        label="SISTEMA:"
                        value={sistemaSeleccionado.nproyecto}
                        ext=''
                      />
                      <Grid item container xs={4} direction="column" spacing={1}>
                        <Grid item container xs={12} direction="row" justifyContent="flex-end" alignItems="flex-start">
                          <Grid item>
                            <Typography>{formatPeriodo(fechad.finicio)}-{formatPeriodo(fechad.ffin)}</Typography>
                            </Grid>
                            <Grid item>
                            <Tabs  value={masindc} onChange={handleChange} className={classes.indicator}>
                            {/* {value == 2 ? (): ( )} */}
                            <Tab className={classes.tab} label={<Grid item container direction="row"><Assignment/><Typography variant="h6">
                                            Solicitudes </Typography></Grid>} value={1}/>
                            <Tab className={classes.tab} label={<Grid item container direction="row"><InsertChart/><Typography variant="h6">
                            Otros Indicadores </Typography></Grid>} value={2} />
                            </Tabs>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item container > 
                      <Grid item xs={12}>
                      <TabPanel value={masindc} index={1}>
                      <TablaV2
                          keyTabla='indGral'
                          columns={columns}
                          rows={sistemaSeleccionado.solicitudes}
                          columnKey="idsolicitud"
                          filterGeneralDisabled={false}
                        />
                      </TabPanel>
                      <TabPanel value={masindc} index={2}>
                        <Detalles sistemaSeleccionado={sistemaSeleccionado}/>
                      </TabPanel>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Card>
            <CardContent>
              <Typography variant="h4" align="center">
                No hay sistema seleccionado
              </Typography>
            </CardContent>
          </Card>
        )}
        <Grid item></Grid>
      </Grid>
    </>
  );
};
export default AvanceSolicitud;
